import BonusBanner from './BonusBanner';

export default BonusBanner;
